import { Injectable } from '@angular/core'
import {
  RootState,
  selectActiveSession,
  selectActualReconDate,
  selectSelectedReconDate,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { filter, map, take } from 'rxjs/operators'
import { SessionsService } from '../sessions-service/sessions.service'

@Injectable({
  providedIn: 'root',
})
export class BlankSessionService {
  constructor(
    private readonly store: Store<RootState>,
    private readonly sessionService: SessionsService,
  ) {}

  async createBlankSessionIfNotInSession() {
    const isInSession = await this.store
      .select(selectActiveSession)
      .pipe(
        take(1),
        map(x => !!x),
      )
      .toPromise()

    if (isInSession) {
      return
    }

    const selectedReconDate = await this.store
      .select(selectSelectedReconDate)
      .pipe(
        take(1),
        filter((val): val is Date => val != null),
      )
      .toPromise()

    const defaultReconDate = await this.store
      .select(selectActualReconDate)
      .pipe(
        take(1),
        filter((val): val is Date => val != null),
      )
      .toPromise()

    const session = await this.sessionService.create(
      [],
      selectedReconDate !== undefined ? selectedReconDate : defaultReconDate,
      new Date(),
      false,
    )

    if (session) {
      await this.sessionService.activateSession(session.id)
    }
  }
}
